<template>
    <Modal @close="onClose">
        <template v-slot:content>
            <div class="video__modal">
                <div class="maintain-aspect-ratio" :class="{ 'is-blocked': showChoiceModal }">
                    <iframe
                        :src="youtubeEmbedUrl"
                        frameborder="0"
                        allow="autoplay; encrypted-media"
                        allowfullscreen></iframe>
                </div>
                <div v-if="showChoiceModal" class="video-consent">
                    <h3 class="video-consent__title">Watch Video</h3>
                    <p class="video-consent__description">
                        Choose how you want to watch this video.
                    </p>
                    <div class="video-consent__actions">
                        <button type="button" class="video-consent__button" @click="playEmbeddedVideo">
                            Play in embedded player
                        </button>
                        <button type="button" class="video-consent__link" @click="watchOnYouTube">
                            Watch on YouTube
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>

    import Modal from '@/components/Modal'
    import { hasMultimediaConsent, setTrustArcConsentLevel, shouldPromptMultimediaPlayerChoice } from '@/helpers/trustArcConsent'

    export default {
        name: 'GenericVideoModal',
        components: {
          Modal
        },
        data() {
            return {
                isConsent: false,
                showPlayerChoice: false
            }
        },
        computed: {
            youtubeEmbedUrl() {
                const videoId = this.$route.params.videoId
                if (!videoId) {
                    return null
                }

                const autoplay = this.showChoiceModal ? 0 : 1
                return `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=${autoplay}&rel=0&showinfo=0`
            },
            youtubeWatchUrl() {
                const videoId = this.$route.params.videoId
                if (!videoId) {
                    return null
                }

                return `https://www.youtube.com/watch?v=${encodeURIComponent(videoId)}`
            },
            showChoiceModal() {
                return this.showPlayerChoice || !this.isConsent
            }
        },
        mounted() {
            this.updateConsent()
            window.addEventListener('multimediaConsentChanged', this.updateConsent)
        },
        beforeUnmount() {
            window.removeEventListener('multimediaConsentChanged', this.updateConsent)
        },
        methods: {
            onClose() {
                // Modal close is treated as decline; leave consent unchanged.
                this.isConsent = false
                this.showPlayerChoice = false
            },
            updateConsent() {
                this.isConsent = hasMultimediaConsent()
                this.showPlayerChoice = shouldPromptMultimediaPlayerChoice()
            },
            playEmbeddedVideo() {
                setTrustArcConsentLevel('multimedia')
                this.isConsent = true
                this.showPlayerChoice = false
            },
            watchOnYouTube() {
                if (!this.youtubeWatchUrl) {
                    return
                }

                window.open(this.youtubeWatchUrl, '_blank', 'noopener,noreferrer')
            }
        }
    }

</script>
